export default __webpack_public_path__ + "./fonts/logo-home-white.110e3aa2.svg";